<div class="row">

    <div class="col-lg-5">
        <div class="row">

            <span class="p-float-label">
                <input type="text" pInputText [(ngModel)]="matchName" #name> 
                <label for="float-input">Insert a name for this mark</label>
            </span>
        </div>
    </div>

    <div class="col-lg-6">
        <div class="row">

            <div class="col-sm-6">
                <p-button (click)="onMatchInseparable()" label="Join" [disabled]="!(optItemsMatched.length > 1 && matchName.length > 0)"></p-button>
            </div>
            <div class="col-sm-6">
                <p-button (click)="onMatchInConflict()" label="Mark conflict" [disabled]="!(optItemsMatched.length > 1 && matchName.length > 0)"></p-button>
            </div>

        </div>
    </div>
    <div class="col-lg-1">
        <button type="button" class="close" aria-label="Close" title="Close" (click)="vehicleService.onCloseForm()">
             <span aria-hidden="true"> &times;</span>
          </button>
    </div>
</div>

<hr>
<p-pickList [source]="optItems" [target]="optItemsMatched" [responsive]="true" filterBy="name" sourceHeader="All optional" targetHeader="Optional to mark" dragdrop="true">


    <ng-template let-optItem pTemplate="item">
        <div>
            <div style="font-size:10px">{{optItem.name}} - {{optItem.weight}}</div>
        </div>
    </ng-template>

</p-pickList>